import { enableAnalytics } from 'api';
import { usePostHog } from 'posthog-js/react';
import { useCallback } from 'react';
import useUserDetails from 'utils/useUserDetails/useUserDetails';
import { AnalyticsEvent, EventProperties, LogEventFn } from './events';

const useAnalytics = () => {
  const { userId, fullName } = useUserDetails();

  const posthog = usePostHog();

  const logEvent = useCallback<LogEventFn>(
    <E extends AnalyticsEvent>(event: E, properties: EventProperties<E>) => {
      if (!posthog || !enableAnalytics) {
        return;
      }

      const payload = {
        ...(properties ?? {}),
        platform: 'web',
        userId,
        name: fullName,
      };

      posthog.capture(event, payload);
    },
    [posthog, userId, fullName],
  );

  return { logEvent };
};

export default useAnalytics;
